module.exports = __webpack_public_path__ + "img/thumbnail_RedKangaroo_j_albino.24a2ee32.png";